import { useEffect } from "react";
import { useLocation } from "react-router-dom";

function usePageTracking() {
  const location = useLocation();

  useEffect(() => {
    if (typeof window.gtag === "function" && window.location.hostname !== "localhost") {
      window.gtag("config", "AW-17719520975", {
        page_path: location.pathname + location.search,
      });
    }
  }, [location]);
}

export default usePageTracking;